"use client";

import {
  activateWorkspaceApp,
  deactivateWorkspaceApp,
  getUserWorkspaceAppLayout,
  getWorkspaceAppActivationPreview,
  getWorkspaceAppDeactivationPreview,
  listEffectiveWorkspaceApplications,
  listWorkspaceApplicationCatalog,
  updateUserWorkspaceAppLayout,
} from "../../generated/api/applications/applications";
import {
  applyWorkspacePreset,
  deactivateWorkspacePreset,
  getWorkspacePresetApplyPreview,
  getWorkspacePresetDeactivationPreview,
  getWorkspacePresetUpgradePreview,
  listWorkspacePresetInstallations,
  listWorkspacePresets,
  upgradeWorkspacePreset,
} from "../../generated/api/preset/preset";

export const workspaceAppsApi = {
  listEffectiveApplications: listEffectiveWorkspaceApplications,
  getUserLayout: getUserWorkspaceAppLayout,
  updateUserLayout: updateUserWorkspaceAppLayout,
  listApplicationCatalog: listWorkspaceApplicationCatalog,
  getActivationPreview: getWorkspaceAppActivationPreview,
  activateApplication: activateWorkspaceApp,
  getDeactivationPreview: getWorkspaceAppDeactivationPreview,
  deactivateApplication: deactivateWorkspaceApp,
  listPresets: listWorkspacePresets,
  listPresetInstallations: listWorkspacePresetInstallations,
  getPresetApplyPreview: getWorkspacePresetApplyPreview,
  applyPreset: applyWorkspacePreset,
  getPresetDeactivationPreview: getWorkspacePresetDeactivationPreview,
  deactivatePreset: deactivateWorkspacePreset,
  getPresetUpgradePreview: getWorkspacePresetUpgradePreview,
  upgradePreset: upgradeWorkspacePreset,
};

export type EffectiveWorkspaceApplications = Awaited<
  ReturnType<typeof workspaceAppsApi.listEffectiveApplications>
>;
export type UserWorkspaceAppLayout = Awaited<
  ReturnType<typeof workspaceAppsApi.getUserLayout>
>;
export type WorkspaceApplicationCatalog = Awaited<
  ReturnType<typeof workspaceAppsApi.listApplicationCatalog>
>;
export type WorkspaceApplicationCatalogItem = WorkspaceApplicationCatalog["applications"][number];
export type WorkspaceAppActivationPreview = Awaited<
  ReturnType<typeof workspaceAppsApi.getActivationPreview>
>;
export type WorkspaceAppDeactivationPreview = Awaited<
  ReturnType<typeof workspaceAppsApi.getDeactivationPreview>
>;
export type WorkspacePresetCatalog = Awaited<
  ReturnType<typeof workspaceAppsApi.listPresets>
>;
export type WorkspacePresetCatalogItem = WorkspacePresetCatalog["presets"][number];
export type WorkspacePresetInstallations = Awaited<
  ReturnType<typeof workspaceAppsApi.listPresetInstallations>
>;
export type WorkspacePresetInstallation = WorkspacePresetInstallations["installations"][number];
export type WorkspacePresetApplyPreview = Awaited<
  ReturnType<typeof workspaceAppsApi.getPresetApplyPreview>
>;
